import { BehaviorSubject, ReplaySubject, Subject, scheduled } from "rxjs";

import { Funcao } from "../models/funcao";
import { Injectable } from "@angular/core";

@Injectable()
export class FuncaoState {

  private loading$: Subject<boolean> = new Subject<boolean>();

  private categorias$ = new BehaviorSubject<string[]>([]);

  private funcoes$ = new BehaviorSubject<Funcao[]>([]);
  private funcaoSelecionada$ = new BehaviorSubject<Funcao>(null);
  private funcoesFiltradas$ = new BehaviorSubject<Funcao[]>([]);
  private funcoesFiltradasNaoAdicionadas$ = new BehaviorSubject<Funcao[]>([]);
  private funcoesAdicionadas$ = new BehaviorSubject<Funcao[]>([]);

  reset() {
    this.setLoading(false);
    this.setCategorias([]);
    this.setFuncoes([]);
    this.setfuncoesAdicionadas([]);
  }

  getLoading$() {
    return this.loading$;
  }

  setLoading(isLoading: boolean) {
    this.loading$.next(isLoading);
  }

  getCategorias$() {
    return this.categorias$.asObservable();
  }

  setCategorias(categorias: string[]) {
    this.categorias$.next(categorias);
  }

  getFuncoes$() {
    return this.funcoes$.asObservable();
  }

  setFuncoes(funcoes: Funcao[]) {
    const funcaoesAdicionadas = this.funcoesAdicionadas$.getValue();
    this.funcoes$.next(funcoes);
    this.funcoesFiltradas$.next(funcoes);
    this.funcoesFiltradasNaoAdicionadas$.next(
      funcoes.filter(f => !funcaoesAdicionadas.map(_f => _f.nome).includes(f.nome))
    );
  }

  getFuncoesFiltradas$() {
    return this.funcoesFiltradas$.asObservable();
  }

  getFuncoesFiltradasNaoAdicionadas$() {
    return this.funcoesFiltradasNaoAdicionadas$.asObservable();
  }

  getFuncaoFiltradaByNome(nome: string): Funcao {
    return this.funcoesFiltradas$.getValue().find(f => f.nome === nome);
  }

  filtrarFuncoes(input: string) {
    const funcaoSelecionada = this.funcaoSelecionada$.getValue();
    const funcoesAdicionadas = this.funcoesAdicionadas$.getValue();
    const filtradas = this.funcaoFilterByName(input);
    const filtradasNaoAdicionadas = filtradas.filter(f => !funcoesAdicionadas.map(_f => _f.nome).includes(f.nome));

    if (funcaoSelecionada)
      this.setFuncaoSelecionada(null);

    this.funcoesFiltradas$.next(filtradas);
    this.funcoesFiltradasNaoAdicionadas$.next(filtradasNaoAdicionadas);
  }

  private funcaoFilterByName(input: string): Funcao[] {
    const funcoes = this.funcoes$.getValue();

    if (!input)
      return funcoes;

    return funcoes.filter(option => option?.nome?.toLowerCase().includes(input.toLowerCase()));
  }

  setfuncoesAdicionadas(funcoes) {
    funcoes.sort(this.compareNome);
    return this.funcoesAdicionadas$.next(funcoes);
  }

  compareNome(a: any, b: any) {
    if (a.nome < b.nome) {
      return -1;
    }
    if (a.nome > b.nome) {
      return 1;
    }
    return 0;
  }

  getfuncoesAdicionadas$() {
    return this.funcoesAdicionadas$.asObservable();
  }

  getfuncoesAdicionadas() {
    return this.funcoesAdicionadas$.getValue();
  }

  addFuncaoAdicionada() {
    const currentValue = this.funcoesAdicionadas$.getValue();
    const newValue = this.funcaoSelecionada$.getValue();
    this.setfuncoesAdicionadas([...currentValue, newValue]);
    this.setFuncaoSelecionada(null);
  }

  removeFuncaoAdicionada(funcaoRemove: Funcao) {
    const currentValue = this.funcoesAdicionadas$.getValue();
    this.setfuncoesAdicionadas(currentValue.filter(funcao => funcao !== funcaoRemove));
  }

  getfuncoesNaoAdicionadas$() {
    const funcaoesAdicionadas = this.funcoesAdicionadas$.getValue();
    return scheduled(this.funcoes$.getValue().filter(f => !funcaoesAdicionadas.includes(f)), null);
  }

  getFuncaoSelecionada$() {
    return this.funcaoSelecionada$.asObservable();
  }

  setFuncaoSelecionada(funcao: Funcao) {
    this.funcaoSelecionada$.next(funcao);
  }
}
